import { http } from '@/core/api/';
const apiUrl = 'api/actionPlan';

export const getPriorityLevelTypes = () => {
  return http.get(`${apiUrl}/priorityleveltypes`);
};

export const getActionPlanStatus = () => {
  return http.get(`${apiUrl}/statuses`);
};

export const search = (params) => {
  return http.get(`${apiUrl}/search`, { params });
};

export const patch = (id, payload) => http.patch(`${apiUrl}/${id}`, payload);

export const saveFollowUp = (payload) => {
  return http.post(`${apiUrl}/followup/save`, payload);
};

export const getLatestFollowup = (actionPlanId, academicYearId) => {
  return http.get(
    `${apiUrl}/followup/latest/${actionPlanId}/${academicYearId}`
  );
};

export const saveYearClosing = (payload) => {
  return http.post(`${apiUrl}/yearclosing/save`, payload);
};

export const getFollowUps = (actionPlanId, currentPage, pageSize) => {
  return http.get(`${apiUrl}/followup/list/${actionPlanId}`, {
    params: {
      currentPage,
      pageSize,
    },
  });
};

export const canFollowUpInHistory = (actionPlanId, academicYearId) => {
  return http.get(
    `${apiUrl}/followup/canfollowupinhistory/${actionPlanId}/${academicYearId}`
  );
};

export const setNoActionStatus = (payload) => {
  return http.patch(`${apiUrl}/noaction`, payload);
};

export const getHistory = (id, params) =>
  http.get(`${apiUrl}/${id}/history`, { params });

export const sendReport = (payload) =>
  http.post(`${apiUrl}/sendreport`, payload);
